require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./celebratingwomenininvesting.json") })
        }
      }, "path---celebratingwomenininvesting");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---celebratingwomenininvesting!./.cache/json/celebratingwomenininvesting.json
// module id = 1053
// module chunks = 231608221292675